import { render, staticRenderFns } from "./PurchaseContractMgmt.vue?vue&type=template&id=22c96442"
import script from "./PurchaseContractMgmt.vue?vue&type=script&lang=js"
export * from "./PurchaseContractMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseContractMgmt.vue?vue&type=style&index=0&id=22c96442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports